module.exports = __webpack_public_path__ + "static/media/app5.cf5f7044.png";